import { useSelector } from 'react-redux'

import { useGetPaymentsOnMount, selectAllPayments } from '@user/store/payments'

import { PaymentsProps } from './Payments'

export function useData(params: PaymentsProps) {
  const { externalSvcLocId } = params

  const status = useGetPaymentsOnMount(externalSvcLocId)
  const payments = useSelector(selectAllPayments)

  const paymentsCount = status === 'success' ? `(${payments.length})` : ''
  const title = `Payment Methods ${paymentsCount}`

  return {
    title,
    status,
    payments,
  }
}
